import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import {Card, Icon, Grid, Button} from 'semantic-ui-react';
import {getSystemParameterValue} from '../../../common/util/parametersUtils';
import {dashboardDateFormat} from '../../../common/constants/datesFormat';
import {getElapsedTimeLikeString} from '../../../common/util/time';
import {Actions} from '../../../common/actions';
import ItemTable from './table';
import './item.scss';

class Item extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
    this.state = {
      'labelsEmissionDate': props.shiftData.labelsEmissionDate,
      'missingTimeForNextShift': '00:00:00',
      'missingTimeForNextShiftInSeconds': 0,
      'showAlertInTimer': false,
      'restartTimer': true,
      'sendToPrint': false,
    };
  }

  componentDidMount() {
    const {labelsEmissionDate} = this.state;
    if (labelsEmissionDate) {
      const nextShiftTime =
        this.getNextShiftTimeInDateFormat(labelsEmissionDate);
      this.startTimer(nextShiftTime);
    }
  }

  componentDidUpdate() {
    const {labelsEmissionDate, restartTimer, sendToPrint} = this.state;
    const {shiftData, printLabelsSuccessfully} = this.props;
    const newLabelsEmissionDate = shiftData.labelsEmissionDate;

    if (
      newLabelsEmissionDate &&
      labelsEmissionDate !== newLabelsEmissionDate &&
      restartTimer
    ) {
      this.stopTimer();
      this.setState({
        'labelsEmissionDate': newLabelsEmissionDate,
      });
      const nextShiftTime = this.getNextShiftTimeInDateFormat(
        newLabelsEmissionDate
      );
      this.startTimer(nextShiftTime);
    }

    if (printLabelsSuccessfully && sendToPrint) {
      this.setState({'sendToPrint': false}, () => this.props.fetchNextShifts());
    }
  }

  componentWillUnmount() {
    const {shiftData} = this.props;
    this.stopTimer();
    this.props.setMissingTimeForNextShift(
      shiftData.code,
      this.state.missingTimeForNextShiftInSeconds
    );
  }

  getNextShiftTimeInDateFormat(timeInString) {
    return moment(timeInString);
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  playAlert(path) {
    const sound = new Audio(path);
    sound.play();
  }

  getElapsedTimeInSeconds(elapsedTime) {
    let days = 0;
    let time = elapsedTime;

    const elapsedTimeHasDays = elapsedTime.includes('d ');
    if (elapsedTimeHasDays) {
      const elapsedTimeParsed = elapsedTime.split('d ');
      days = elapsedTimeParsed[0];
      time = elapsedTimeParsed[1];
    }
    const timeParsed = time.split(':');

    return (
      parseInt(days, 10) * 24 * 3600 +
      parseInt(timeParsed[0], 10) * 3600 +
      parseInt(timeParsed[1], 10) * 60 +
      parseInt(timeParsed[2], 10)
    );
  }

  restartTimerInDashboard() {
    const {shiftData} = this.props;

    this.stopTimer();
    this.setState({
      'restartTimer': true,
      'showAlertInTimer': false,
    });
    this.props.restartTimer(shiftData.code, true);
  }

  updateTimeInDashboard(
    {elapsedTime, elapsedTimeInSeconds},
    timeForPreviousAlarm,
    existOrders
  ) {
    const {shiftData} = this.props;
    this.setState({
      'missingTimeForNextShift': elapsedTime,
      'missingTimeForNextShiftInSeconds': elapsedTimeInSeconds,
      'showAlertInTimer': false,
    });
    this.props.setMissingTimeForNextShift(
      shiftData.code,
      this.state.missingTimeForNextShiftInSeconds
    );
    if (elapsedTimeInSeconds === 30) {
      const {shiftData} = this.props;
      this.props.restartTimer(shiftData.code, false);
    }
    if (existOrders && elapsedTimeInSeconds === timeForPreviousAlarm * 60) {
      const previousAlertPath = '/sounds/railroad.mp3';
      this.playAlert(previousAlertPath);
    }
  }

  startTimer(nextShiftTime) {
    const {systemParameters, shiftData} = this.props;
    const existOrders = shiftData.pickingZones && shiftData.pickingZones.length;
    const keepAlertTime =
      getSystemParameterValue(
        systemParameters,
        'PICKING_DASHBOARD_ALERT_TIME'
      ) || 180;
    const timeForPreviousAlarm =
      getSystemParameterValue(
        systemParameters,
        'PICKING_DASHBOARD_PREVIOUS_ALARM'
      ) || 1;

    this.timer = setInterval(() => {
      const elapsedTime = getElapsedTimeLikeString(nextShiftTime);
      const elapsedTimeInSeconds = this.getElapsedTimeInSeconds(elapsedTime);
      if (nextShiftTime >= moment()) {
        this.updateTimeInDashboard(
          {elapsedTime, elapsedTimeInSeconds},
          timeForPreviousAlarm,
          existOrders
        );
        return;
      }
      if (elapsedTimeInSeconds >= keepAlertTime) {
        this.restartTimerInDashboard();
        return;
      }
      if (existOrders && elapsedTimeInSeconds <= 1) {
        this.setState({
          'restartTimer': false,
          'showAlertInTimer': true,
          'missingTimeForNextShift': '00:00:00',
          'missingTimeForNextShiftInSeconds': elapsedTimeInSeconds,
        });
        this.props.restartTimer(shiftData.code, false);
      }
      if (
        existOrders &&
        elapsedTimeInSeconds >= 1 &&
        elapsedTimeInSeconds < keepAlertTime
      ) {
        this.setState({'showAlertInTimer': true});
        const alertPath = '/sounds/alarma.mp3';
        this.playAlert(alertPath);
      }
    }, 1000);
  }

  onPrintClick(printOnlyCasabaca) {
    const {shiftData, systemParameters} = this.props;
    const orderCode = shiftData.code;
    const quantityLabelsToCut =
      getSystemParameterValue(systemParameters, 'PICKING_LABELS_TO_CUT') || 10;
    this.props.printPickingLabels(
      orderCode,
      quantityLabelsToCut,
      printOnlyCasabaca
    );
    this.setState({'sendToPrint': true});
  }

  renderAditionalInfo(icon, title, value) {
    const {shiftData} = this.props;
    const existOrders = shiftData.pickingZones && shiftData.pickingZones.length;
    const alertBg =
      icon === 'time' && existOrders && this.state.showAlertInTimer ?
        'alert' :
        '';
    return (
      <Grid columns={2} className='aditional-info'>
        <Grid.Row className={alertBg}>
          <Grid.Column width={3} className='icon-container'>
            <Icon name={icon} size='small' />
          </Grid.Column>
          <Grid.Column width={13} textAlign='left' className='info'>
            <div className='title'>{title}</div>
            <div className='value'>{value}</div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  render() {
    const {shiftData, printingLabels, zonesList} = this.props;
    const {missingTimeForNextShift} = this.state;
    const labelsEmissionFormatted = shiftData.labelsEmissionDate ?
      moment(shiftData.labelsEmissionDate).format(dashboardDateFormat) :
      '';
    const dispatchTimeFormatted = shiftData.dispatchTime ?
      moment(shiftData.dispatchTime).format(dashboardDateFormat) :
      '';

    return (
      <Card className='picking-order-option'>
        <Card.Content>
          <div className='title-bar'>
            <div className='title'>
              <h2>{shiftData.name}</h2>
              <div className='title-bar-actions'>
                <Button
                  type='button'
                  primary
                  className='btn-green'
                  disabled={
                    printingLabels ||
                    !shiftData.pickingZones ||
                    !shiftData.pickingZones.length
                  }
                  onClick={() => this.onPrintClick(true)}
                >
                  Casabaca
                </Button>
                <Button
                  type='button'
                  primary
                  className='toyota-primary'
                  disabled={
                    printingLabels ||
                    !shiftData.pickingZones ||
                    !shiftData.pickingZones.length
                  }
                  onClick={() => this.onPrintClick(false)}
                >
                  Imprimir
                </Button>
              </div>
            </div>
            <div className='next-schedule'>
              Próximo Turno: {labelsEmissionFormatted} - {dispatchTimeFormatted}
            </div>
          </div>

          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column width={11}>
                <ItemTable shiftData={shiftData} zonesList={zonesList} />
              </Grid.Column>
              <Grid.Column width={5}>
                {this.renderAditionalInfo(
                  'time',
                  'Tiempo Restante:',
                  missingTimeForNextShift
                )}
                {this.renderAditionalInfo(
                  'tag',
                  'Etiquetas',
                  _.sumBy(shiftData.pickingZones, 'labels')
                )}
                {this.renderAditionalInfo(
                  'user',
                  'Personal',
                  _.sumBy(shiftData.pickingZones, 'people')
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'zonesList': state.pickingDashboard.zonesList,
    'systemParameters': state.parameters.list,
    'printingLabels': state.pickingDashboard.printingLabels,
    'printLabelsSuccessfully': state.pickingDashboard.printLabelsSuccessfully,
  };
};

const {
  printPickingLabels,
  fetchNextShifts,
} = Actions;

export default connect(mapStateToProps, {
  printPickingLabels,
  fetchNextShifts,
})(Item);
